var Splitting = window.Splitting;
var anime = window.anime;

document.addEventListener("DOMContentLoaded", function () {
  Splitting();
});

document.body.addEventListener("start:animation", function () {
  var bannerTitle = document.querySelector(".banner-title");
  if (bannerTitle) {
    bannerTitle.classList.add("fade-in");

    anime({
      targets: ".banner-title .word",
      translateX: [-60, 0],
      opacity: [0, 1],
      easing: "easeOutQuint",
      duration: 2000,
      delay: function (el, i) {
        return i * 100;
      },
    });

    anime({
      targets: ".banner-content",
      translateX: [-60, 0],
      opacity: [0, 1],
      easing: "easeOutQuint",
      duration: 2000,
      delay: 500,
    });

    anime({
      targets: ".banner-actions a",
      translateY: [60, 0],
      opacity: [0, 1],
      easing: "easeOutQuint",
      duration: 2000,
      delay: function (el, i) {
        return 1000 + i * 100;
      },
    });
  }
});
